/**
 * Как в конце хода строительства считаются очки за присоединенное к городам.
 * Само строительство очков не дает: из прироста очков городов игрока
 * вычитаются очки новых строений (calcPendingBuildingsWinPoints), и остаются
 * очки за подключенные к городам старые строения и ключевые точки.
 *
 * По правилу вычитаются очки только тех новых строений, что вошли в город
 * игрока. Раньше вычитались все: строение вне города (крепость в поле, ферма,
 * не вошедшая ни в один свой город) забирало у игрока очки, которых он за него
 * не получал, — крепость −3, ферма −1.
 *
 * Записи матчей проигрываются через редьюсеры, поэтому старые записи должны
 * считать по-старому, иначе очки разошлись бы с сыгранными. Флаг
 * isBuildingWinPointsInCitiesRule ставит LOAD_STATE (см. loadState в
 * redux/actions); у старых записей его нет — только у них он false.
 *
 * @param {Object} [gameState] - состояние партии
 * @returns {boolean}
 */
export const checkIfBuildingWinPointsInCitiesRule = (gameState) => (
  gameState?.isBuildingWinPointsInCitiesRule !== false
);
